export const FOCUSABLE_SELECTORS = "a[href], button:not([disabled])";

export const getFocusableElements = (
  container: HTMLElement | null,
  selectors: string = FOCUSABLE_SELECTORS
): HTMLElement[] => {
  if (!container) return [];
  return Array.from(container.querySelectorAll<HTMLElement>(selectors));
};

export const handleTabNavigation = (
  event: KeyboardEvent,
  focusableElements: HTMLElement[]
): void => {
  if (focusableElements.length === 0) return;

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];
  const activeElement = document.activeElement;

  if (event.shiftKey) {
    if (activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    }
  } else {
    if (activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }
};

export const createFocusTrapHandler = (
  container: HTMLElement | null,
  onEscape: () => void,
  selectors: string = FOCUSABLE_SELECTORS
): ((event: KeyboardEvent) => void) => {
  return (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      onEscape();
      return;
    }

    if (event.key === "Tab") {
      const focusableElements = getFocusableElements(container, selectors);
      handleTabNavigation(event, focusableElements);
    }
  };
};
